{
  "version": "v4.2.5",
  "name": "SwapMaxIn",
  "bytecodeTemplate": "0101030002001fb41700{0}160047cc17011601c5194c0516000d0c{0}d465b302f9{1}{4}{5}a3{3}{1}{4}{5}{6}{1}{7}13070c{2}0105",
  "fieldsSig": {
    "names": [
      "dexAccount",
      "sender",
      "router",
      "pair",
      "tokenInId",
      "amountInMax",
      "amountOut",
      "deadline"
    ],
    "types": [
      "IDexAccount",
      "Address",
      "Router",
      "TokenPair",
      "ByteVec",
      "U256",
      "U256",
      "U256"
    ],
    "isMutable": [
      false,
      false,
      false,
      false,
      false,
      false,
      false,
      false
    ]
  },
  "functions": [
    {
      "name": "main",
      "paramNames": [],
      "paramTypes": [],
      "paramIsMutable": [],
      "returnTypes": []
    }
  ]
}